import React from 'react';
import { IPlanContent } from '../typings/planContent.types';
import { createPlanNameMatcher } from './utils/PlanMetaHelper';
import {
  defaultEstimatesDialog,
  defaultKeyDetails,
  dualKeyDetailsAddons,
  electricityKeyDetailsAddons,
  gasKeyDetailsAddons,
} from './common/planDefaults';
import { createOnlineCreditsBoxContent } from './common/onlineCredits';
import { OriginGoVariablePromoBox, UsageRatePerkContent } from './common/originGoVariablePromobox';

import { InternetOfferPerk } from './common/internetOfferPerk';

const PLAN_TONE = 'promote';

const PromoBox = <OriginGoVariablePromoBox />;

export const originGoVariableContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Go Variable']),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on a 12 month benefit period',
      },
    },
    bannerContent: undefined,
    keyFeatures: {
      defaultState: {
        defaultFuel: [],
      },
    },
    signUpOptions: {
      defaultState: {
        defaultFuel: [],
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: defaultKeyDetails,
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        dual: dualKeyDetailsAddons,
        gas: gasKeyDetailsAddons,
        electricity: electricityKeyDetailsAddons,
      },
    },
    perkAccordion: {
      defaultState: {
        defaultFuel: [],
      },
      NSW: {
        dual: [InternetOfferPerk],
        gas: [InternetOfferPerk],
        electricity: [InternetOfferPerk],
        defaultFuel: null,
      },
      QLD: {
        dual: [InternetOfferPerk],
        gas: [InternetOfferPerk],
        electricity: [InternetOfferPerk],
        defaultFuel: null,
      },
      VIC: {
        dual: [InternetOfferPerk],
        gas: [InternetOfferPerk],
        electricity: [InternetOfferPerk],
        defaultFuel: null,
      },
      SA: {
        dual: [InternetOfferPerk],
        gas: [InternetOfferPerk],
        electricity: [InternetOfferPerk],
        defaultFuel: null,
      },
      ACT: {
        dual: [InternetOfferPerk],
        gas: [InternetOfferPerk],
        electricity: [InternetOfferPerk],
        defaultFuel: null,
      },
      WA: {
        gas: [InternetOfferPerk, UsageRatePerkContent],
        electricity: [],
        defaultFuel: null,
      },
    },
    promoBox: {
      WA: {
        gas: PromoBox,
        defaultFuel: null,
      },
    },
    onlineCredits: createOnlineCreditsBoxContent(
      PLAN_TONE,
      '$300 electricity bill credit',
      'New/moving customers only. Plan must be active on 31 December 24 and you must not have received a credit in the previous 12 months. Not redeemable for cash.'
    ),
    estimatesDialog: defaultEstimatesDialog({
      onlineCreditAmount: 300,
    }),
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'blue',
              odsCore: PLAN_TONE,
            },
            promobox: {
              styleGuide: 'blue',
              odsCore: PLAN_TONE,
            },
            bannerText: {
              styleGuide: 'white',
              odsCore: 'white',
            },
          },
          imageUrl:
            'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/pictograms/pictogram_origin-go-variable.svg',
          imageForFuelType: {
            electricity:
              'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-go-variable.svg',
            gas: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-go-variable.svg',
            dual: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-go-variable.svg',
          },
          applyPromoBorder: false,
        },
      },
    },
    tagLine: {
      defaultState: {
        defaultFuel: 'An energy plan with variable rates',
      },
      QLD: {
        defaultFuel: 'An energy plan with variable rates',
      },
    },
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/origin-go-variable.html',
      },
    },
  },
};
